import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
    ["what-we-do", "What we do"],
    ["sectors", "Sectors"],
    ["network", "Network"],
    ["contact", "Contact"],
];

const Footer = () => (
    <footer className="bg-night pb-10 pt-16 text-paper">
        <div className="container-x">
            <div className="flex flex-col gap-10 border-b border-paper/10 pb-10 md:flex-row md:items-start md:justify-between">
                <Logo light />
                <nav className="flex flex-wrap gap-x-8 gap-y-3">
                    {LINKS.map(([id, label]) => (
                        <button
                            key={id}
                            data-testid={`footer-link-${id}`}
                            onClick={() => scrollToId(id)}
                            className="font-mono text-[11px] uppercase tracking-[0.22em] text-paper/60 transition-colors duration-200 hover:text-paper"
                        >
                            {label}
                        </button>
                    ))}
                </nav>
            </div>
            <div className="flex flex-col gap-3 pt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-paper/40 sm:flex-row sm:items-center sm:justify-between">
                <p data-testid="footer-copyright">
                    © {new Date().getFullYear()} Everlast Partners
                </p>
                <p data-testid="footer-address">
                    50 Milk Street, 16th Floor · Boston, MA 02109
                </p>
                <p>Advisory only — no capital invested, no money managed</p>
            </div>
        </div>
    </footer>
);

export default Footer;
